// Fixed colors for a right / wrong answer: the themes' own success color is not always green.
export const CORRECT_COLOR = '#16a34a';
export const WRONG_COLOR = '#ea580c';
